import { useState, useEffect } from "react";
import { images } from "../../constants/images";
import "../../assets/stylesheets/bootstrap.min.css";
import "../../assets/stylesheets/style.css";
import "../../assets/stylesheets/responsive.css";

export default function SupportAndMaintenance() {
  useEffect(() => {
    document.title = "Ongoing Support & Maintenance | Plural Code";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <main className="wrapper">
        {/* HERO SECTION - Matching Home Page Design */}
        <section
          style={{
            minHeight: "85vh",
            display: "flex",
            alignItems: "center",
            position: "relative",
            overflow: "hidden",
            background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
          }}
        >
          {/* Background Elements */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: `
              radial-gradient(circle at 20% 80%, rgba(255, 215, 0, 0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 40% 40%, rgba(10, 36, 88, 0.2) 0%, transparent 50%)
            `,
            }}
          />

          <div className="container position-relative" style={{ zIndex: 1 }}>
            <div className="row align-items-center min-vh-80">
              <div className="col-lg-7 mb-5 mb-lg-0">
                <div className="text-white">
                  <div
                    className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-4"
                    style={{
                      background: "rgba(255, 215, 0, 0.15)",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255, 215, 0, 0.3)",
                    }}
                  >
                    <span style={{ fontSize: "20px" }}>⚡</span>
                    <span
                      className="fw-bold"
                      style={{ fontSize: "14px", color: "#FFD700" }}
                    >
                      24/7 RELIABLE SUPPORT
                    </span>
                  </div>

                  <h1
                    className="display-3 fw-bold mb-4"
                    style={{
                      lineHeight: "1.1",
                      background:
                        "linear-gradient(to right, #FFFFFF 0%, #E6F0FF 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundClip: "text",
                    }}
                  >
                    Ongoing Support & Maintenance
                  </h1>

                  <p
                    className="fs-5 mb-5"
                    style={{
                      color: "#E6F0FF",
                      lineHeight: "1.6",
                      maxWidth: "90%",
                      fontWeight: "300",
                    }}
                  >
                    Your software isn't "done" after launch. Keep it secure,
                    fast, and evolving with your business—without needing an
                    in-house development team.
                  </p>

                  <div className="d-flex flex-wrap gap-3 mb-5">
                    <button
                      onClick={() => {
                        const element =
                          document.getElementById("support-plans");
                        if (element)
                          element.scrollIntoView({ behavior: "smooth" });
                      }}
                      className="btn btn-lg px-5 py-3"
                      style={{
                        background:
                          "linear-gradient(135deg, #FFD700 0%, #FFC107 100%)",
                        border: "none",
                        color: "#0a2458",
                        fontWeight: "600",
                        borderRadius: "12px",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-3px)";
                        e.target.style.boxShadow =
                          "0 15px 40px rgba(255, 215, 0, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      Explore Support Plans
                    </button>

                    <button
                      onClick={() =>
                        (window.location.href =
                          "https://topmate.io/pluralcode/1677497")
                      }
                      className="btn btn-lg px-5 py-3"
                      style={{
                        background: "transparent",
                        border: "2px solid #FFD700",
                        color: "#FFD700",
                        fontWeight: "600",
                        borderRadius: "12px",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = "rgba(255, 215, 0, 0.1)";
                        e.target.style.transform = "translateY(-2px)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = "transparent";
                        e.target.style.transform = "translateY(0)";
                      }}
                    >
                      Get Support Quote
                    </button>
                  </div>

                  <div className="d-flex align-items-center gap-4">
                    <div className="d-flex">
                      {[1, 2, 3, 4].map((i) => (
                        <div
                          key={i}
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            background:
                              i === 4 ? "#FFD700" : "rgba(255, 255, 255, 0.2)",
                            border: "2px solid #0a2458",
                            marginLeft: i > 1 ? "-10px" : "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: i === 4 ? "#0a2458" : "#fff",
                            fontWeight: "600",
                            fontSize: i === 4 ? "12px" : "14px",
                          }}
                        >
                          {i === 4 ? "+200" : i}
                        </div>
                      ))}
                    </div>
                    <p className="mb-0" style={{ color: "#E6F0FF" }}>
                      <strong>Supporting 200+ applications</strong> across 20+
                      industries worldwide
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-5">
                <div style={{ position: "relative" }}>
                  <div
                    style={{
                      position: "absolute",
                      top: "-20px",
                      right: "-20px",
                      bottom: "-20px",
                      left: "-20px",
                      background:
                        "linear-gradient(135deg, rgba(255,215,0,0.2) 0%, rgba(255,215,0,0) 50%)",
                      borderRadius: "25px",
                      transform: "rotate(5deg)",
                    }}
                  />
                  <img
                    src={images?.supportAndMaintenance}
                    className="img-fluid"
                    alt="Support & Maintenance"
                    style={{
                      borderRadius: "20px",
                      boxShadow: "0 25px 50px rgba(0,0,0,0.4)",
                      position: "relative",
                      zIndex: 1,
                    }}
                  />

                  <div
                    style={{
                      position: "absolute",
                      bottom: "-20px",
                      left: "-20px",
                      background: "rgba(255, 255, 255, 0.95)",
                      backdropFilter: "blur(10px)",
                      padding: "20px",
                      borderRadius: "15px",
                      boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
                      width: "220px",
                      zIndex: 2,
                    }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "12px",
                          background:
                            "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          fontSize: "24px",
                        }}
                      >
                        ⚡
                      </div>
                      <div>
                        <div
                          className="fw-bold fs-4"
                          style={{ color: "#0a2458" }}
                        >
                          99.9%
                        </div>
                        <div className="fs-12" style={{ color: "#0A2458" }}>
                          Average Uptime
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* WHY ONGOING SUPPORT MATTERS - Modern Design */}
        <section
          className="py-100"
          style={{ padding: "100px 0", background: "#FFFFFF" }}
        >
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <div style={{ position: "relative" }}>
                  <img
                    src={images?.continuosCare}
                    className="img-fluid rounded-4"
                    alt="Why Support Matters"
                    style={{
                      boxShadow: "0 20px 40px rgba(10, 36, 88, 0.1)",
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      top: "-15px",
                      left: "-15px",
                      width: "70px",
                      height: "70px",
                      background: "#FFD700",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "32px",
                      boxShadow: "0 10px 20px rgba(255, 215, 0, 0.3)",
                    }}
                  >
                    ⚠️
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="mb-4">
                  <span
                    className="px-3 py-1 rounded-pill d-inline-block mb-3"
                    style={{
                      background: "rgba(10, 36, 88, 0.1)",
                      color: "#0a2458",
                      fontWeight: "600",
                      fontSize: "14px",
                    }}
                  >
                    CRITICAL NEED
                  </span>
                  <h2
                    className="display-5 fw-bold mb-4"
                    style={{ color: "#0a2458" }}
                  >
                    Software Needs Continuous Care
                  </h2>
                  <p
                    className="fs-5 mb-5"
                    style={{ color: "#0A2458", lineHeight: "1.6" }}
                  >
                    Building custom software is just the beginning. Like any
                    valuable asset, it needs ongoing maintenance to stay secure,
                    performant, and aligned with your evolving needs.
                  </p>
                </div>

                <h3 className="fw-bold mb-4" style={{ color: "#0a2458" }}>
                  What Happens Without Ongoing Support:
                </h3>

                {[
                  {
                    icon: "🔴",
                    title: "Security Vulnerabilities",
                    description:
                      "New security threats emerge constantly. Without updates, your software becomes vulnerable to attacks.",
                  },
                  {
                    icon: "🔴",
                    title: "Performance Degradation",
                    description:
                      "As data grows and usage increases, performance can suffer without optimization.",
                  },
                  {
                    icon: "🔴",
                    title: "Compatibility Issues",
                    description:
                      "Operating systems, browsers, and third-party services update regularly. Your software needs updates to stay compatible.",
                  },
                  {
                    icon: "🔴",
                    title: "Bug Accumulation",
                    description:
                      "Small issues discovered after launch can compound over time if not addressed.",
                  },
                  {
                    icon: "🔴",
                    title: "Stagnation",
                    description:
                      "Business needs change. Without enhancement capabilities, your software becomes a limitation instead of an asset.",
                  },
                  {
                    icon: "🔴",
                    title: "Technical Debt",
                    description:
                      "Postponing maintenance leads to bigger, more expensive problems down the road.",
                  },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="d-flex gap-3 mb-4 p-3 rounded-3"
                    style={{
                      background:
                        index % 2 === 0
                          ? "rgba(220, 53, 69, 0.05)"
                          : "transparent",
                      borderLeft: `3px solid #dc3545`,
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateX(5px)";
                      e.currentTarget.style.background =
                        "rgba(220, 53, 69, 0.1)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateX(0)";
                      e.currentTarget.style.background =
                        index % 2 === 0
                          ? "rgba(220, 53, 69, 0.05)"
                          : "transparent";
                    }}
                  >
                    <div
                      className="flex-shrink-0"
                      style={{
                        fontSize: "24px",
                        width: "48px",
                        height: "48px",
                        background: "rgba(220, 53, 69, 0.1)",
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {item.icon}
                    </div>
                    <div>
                      <h3
                        className="fs-5 fw-bold mb-2"
                        style={{ color: "#0a2458" }}
                      >
                        {item.title}
                      </h3>
                      <p className="fs-6 mb-0" style={{ color: "#0A2458" }}>
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}

                <div className="mt-5">
                  <div
                    className="p-4 rounded-4"
                    style={{
                      background:
                        "linear-gradient(135deg, rgba(10, 36, 88, 0.05) 0%, rgba(255, 215, 0, 0.05) 100%)",
                      border: "1px solid rgba(10, 36, 88, 0.1)",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        top: "-10px",
                        left: "20px",
                        background: "#0a2458",
                        color: "white",
                        padding: "5px 15px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                      }}
                    >
                      REALITY CHECK
                    </div>
                    <p
                      className="fs-6 mb-3"
                      style={{ fontStyle: "italic", color: "#0A2458" }}
                    >
                      "We initially thought we'd just 'set it and forget it'
                      after launch. Within 6 months we had security issues,
                      performance problems, and urgent feature requests. The
                      support plan saved us from major headaches."
                    </p>
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          background: "#0a2458",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                          marginRight: "12px",
                        }}
                      >
                        C
                      </div>
                      <div>
                        <strong className="fs-6" style={{ color: "#0a2458" }}>
                          CTO, Australian SaaS Company
                        </strong>
                        <p className="fs-6 mb-0" style={{ color: "#0A2458" }}>
                          500+ Users • $2M+ Revenue
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* WHAT'S INCLUDED - Modern Cards */}
        <section
          className="py-100"
          style={{ padding: "100px 0", background: "#F8FAFF" }}
        >
          <div className="container">
            <div className="text-center mb-5">
              <span
                className="px-3 py-1 rounded-pill d-inline-block mb-3"
                style={{
                  background: "rgba(10, 36, 88, 0.1)",
                  color: "#0a2458",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                OUR SERVICES
              </span>
              <h2
                className="display-4 fw-bold mb-4"
                style={{ color: "#0a2458" }}
              >
                Comprehensive Support Services
              </h2>
              <p
                className="fs-5 mx-auto"
                style={{ maxWidth: "600px", color: "#0A2458" }}
              >
                Our support and maintenance plans keep your software healthy,
                secure, and evolving.
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  icon: "🐛",
                  title: "Bug Fixes & Issue Resolution",
                  description: "What we do:",
                  items: [
                    "Monitor for errors and bugs",
                    "Investigate and diagnose issues",
                    "Fix bugs quickly (priority-based)",
                    "Test fixes thoroughly",
                    "Deploy to production",
                  ],
                  response:
                    "Response times: Critical: 4 hours • High: 24 hours • Medium: 48 hours",
                },
                {
                  icon: "🔒",
                  title: "Security Updates & Patches",
                  description: "What we do:",
                  items: [
                    "Monitor security advisories",
                    "Apply security patches",
                    "Update dependencies",
                    "Conduct regular security audits",
                    "SSL certificate renewal",
                  ],
                  response:
                    "Frequency: Critical: Immediate • Regular: Monthly • Audits: Quarterly",
                },
                {
                  icon: "⚡",
                  title: "Performance Monitoring & Optimization",
                  description: "What we do:",
                  items: [
                    "24/7 uptime monitoring",
                    "Performance metrics tracking",
                    "Database query optimization",
                    "Server resource monitoring",
                    "Load time improvements",
                  ],
                  response:
                    "Monitoring includes: Uptime/downtime • Response times • Error rates",
                },
                {
                  icon: "🔄",
                  title: "Compatibility Updates",
                  description: "What we do:",
                  items: [
                    "Update for new OS versions",
                    "Browser compatibility updates",
                    "Third-party API changes",
                    "Framework/language updates",
                    "Accessibility improvements",
                  ],
                  response:
                    "When needed: Major OS releases • Browser updates • Service changes",
                },
                {
                  icon: "✨",
                  title: "Feature Enhancements",
                  description: "What we do:",
                  items: [
                    "Implement new features",
                    "Improve existing functionality",
                    "UI/UX improvements",
                    "Workflow optimizations",
                    "Integration additions",
                  ],
                  response:
                    "Approach: Monthly feature budget • Prioritized queue • Agile process",
                },
                {
                  icon: "💬",
                  title: "Technical Support & Consultation",
                  description: "What we do:",
                  items: [
                    "Answer technical questions",
                    "Troubleshoot user issues",
                    "Provide usage guidance",
                    "Architecture consultation",
                    "Strategic planning",
                  ],
                  response:
                    "Access: Email • Slack/Teams • Consultation calls • Emergency contact",
                },
              ].map((service, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div
                    className="h-100 p-4 rounded-4 position-relative"
                    style={{
                      background: "white",
                      border: "1px solid rgba(10, 36, 88, 0.1)",
                      boxShadow: "0 10px 30px rgba(10, 36, 88, 0.08)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-10px)";
                      e.currentTarget.style.boxShadow =
                        "0 20px 40px rgba(10, 36, 88, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(10, 36, 88, 0.08)";
                    }}
                  >
                    <div
                      className="mb-4 rounded-3 d-inline-flex align-items-center justify-content-center"
                      style={{
                        fontSize: "40px",
                        width: "70px",
                        height: "70px",
                        background: "rgba(10, 36, 88, 0.05)",
                      }}
                    >
                      {service.icon}
                    </div>

                    <h3
                      className="fs-5 fw-bold mb-3"
                      style={{ color: "#0a2458" }}
                    >
                      {service.title}
                    </h3>

                    <p
                      className="fs-6 fw-semibold mb-2"
                      style={{ color: "#0a2458" }}
                    >
                      {service.description}
                    </p>
                    <ul className="mb-3" style={{ paddingLeft: "20px" }}>
                      {service.items.map((item, idx) => (
                        <li
                          key={idx}
                          className="mb-2"
                          style={{ color: "#0A2458", fontSize: "0.9rem" }}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>

                    <div
                      className="mt-4 p-3 rounded-3"
                      style={{ background: "rgba(10, 36, 88, 0.03)" }}
                    >
                      <p
                        className="fs-6 mb-0"
                        style={{ color: "#0A2458", fontWeight: "500" }}
                      >
                        {service.response}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SUPPORT PLANS - Modern Table Design */}
        <section
          id="support-plans"
          className="py-100"
          style={{ padding: "100px 0", background: "#FFFFFF" }}
        >
          <div className="container">
            <div className="text-center mb-5">
              <span
                className="px-3 py-1 rounded-pill d-inline-block mb-3"
                style={{
                  background: "rgba(255, 215, 0, 0.15)",
                  color: "#0a2458",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                SUPPORT PLANS
              </span>
              <h2
                className="display-4 fw-bold mb-4"
                style={{ color: "#0a2458" }}
              >
                Flexible Support Plans for Every Need
              </h2>
              <p
                className="fs-5 mx-auto"
                style={{ maxWidth: "700px", color: "#0A2458" }}
              >
                Choose the support level that fits your business needs and
                budget.
              </p>
            </div>

            <div className="row g-4 mb-5">
              <div className="col-lg-4">
                <div
                  className="h-100 p-4 rounded-4 text-center"
                  style={{
                    background: "white",
                    border: "2px solid #e2e8f0",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.borderColor = "#0a2458";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "#e2e8f0";
                  }}
                >
                  <div className="mb-4">
                    <span
                      className="px-3 py-1 rounded-pill d-inline-block"
                      style={{
                        background: "rgba(10, 36, 88, 0.1)",
                        color: "#0a2458",
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      ESSENTIAL
                    </span>
                  </div>

                  <h3
                    className="fs-4 fw-bold mb-3"
                    style={{ color: "#0a2458" }}
                  >
                    Simple apps, low usage
                  </h3>

                  {/* <div className="mb-4">
                    <span
                      className="display-4 fw-bold"
                      style={{ color: "#0a2458" }}
                    >
                      $800
                    </span>
                    <span className="fs-6" style={{ color: "#0A2458" }}>
                      /month
                    </span>
                  </div> */}

                  <ul
                    className="text-start mb-4"
                    style={{ listStyle: "none", padding: 0 }}
                  >
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Critical: 8-hour response
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Bug fixes & security updates
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Basic performance monitoring
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        2 hours monthly enhancements
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>Email support</span>
                    </li>
                  </ul>

                  <button
                    onClick={() =>
                      (window.location.href =
                        "https://topmate.io/pluralcode/1677497?plan=essential")
                    }
                    className="btn w-100 py-3"
                    style={{
                      background: "transparent",
                      border: "2px solid #0a2458",
                      color: "#0a2458",
                      fontWeight: "600",
                      borderRadius: "8px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = "#0a2458";
                      e.target.style.color = "white";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#0a2458";
                    }}
                  >
                    Choose Essential
                  </button>
                </div>
              </div>

              <div className="col-lg-4">
                <div
                  className="h-100 p-4 rounded-4 text-center position-relative"
                  style={{
                    background: "white",
                    border: "2px solid #0a2458",
                    boxShadow: "0 20px 40px rgba(10, 36, 88, 0.15)",
                    transform: "translateY(-10px)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-15px)";
                    e.currentTarget.style.boxShadow =
                      "0 30px 50px rgba(10, 36, 88, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.boxShadow =
                      "0 20px 40px rgba(10, 36, 88, 0.15)";
                  }}
                >
                  <div className="position-absolute top-0 start-50 translate-middle mt-[-20px]">
                    <span
                      className="px-3 py-1 rounded-pill d-inline-block"
                      style={{
                        background: "#FFD700",
                        color: "#0a2458",
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      MOST POPULAR
                    </span>
                  </div>

                  <div className="mb-4">
                    <span
                      className="px-3 py-1 rounded-pill d-inline-block"
                      style={{
                        background: "rgba(10, 36, 88, 0.1)",
                        color: "#0a2458",
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      PROFESSIONAL
                    </span>
                  </div>

                  <h3
                    className="fs-4 fw-bold mb-3"
                    style={{ color: "#0a2458" }}
                  >
                    Active apps, regular updates
                  </h3>

                  {/* <div className="mb-4">
                    <span
                      className="display-4 fw-bold"
                      style={{ color: "#0a2458" }}
                    >
                      $1,800
                    </span>
                    <span className="fs-6" style={{ color: "#0A2458" }}>
                      /month
                    </span>
                  </div> */}

                  <ul
                    className="text-start mb-4"
                    style={{ listStyle: "none", padding: 0 }}
                  >
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Critical: 4-hour response
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Advanced performance monitoring
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Priority compatibility updates
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        5 hours monthly enhancements
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Email + Slack support
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>Monthly reports</span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Quarterly strategy calls
                      </span>
                    </li>
                  </ul>

                  <button
                    onClick={() =>
                      (window.location.href =
                        "https://topmate.io/pluralcode/1677497?plan=professional")
                    }
                    className="btn w-100 py-3"
                    style={{
                      background:
                        "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                      border: "none",
                      color: "white",
                      fontWeight: "600",
                      borderRadius: "8px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 10px 20px rgba(10, 36, 88, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    Choose Professional
                  </button>
                </div>
              </div>

              <div className="col-lg-4">
                <div
                  className="h-100 p-4 rounded-4 text-center"
                  style={{
                    background: "white",
                    border: "2px solid #FFD700",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 20px 40px rgba(255, 215, 0, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div className="mb-4">
                    <span
                      className="px-3 py-1 rounded-pill d-inline-block"
                      style={{
                        background: "rgba(10, 36, 88, 0.1)",
                        color: "#0a2458",
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      PREMIUM
                    </span>
                  </div>

                  <h3
                    className="fs-4 fw-bold mb-3"
                    style={{ color: "#0a2458" }}
                  >
                    Mission-critical systems
                  </h3>

                  {/* <div className="mb-4">
                    <span
                      className="display-4 fw-bold"
                      style={{ color: "#0a2458" }}
                    >
                      $4,000
                    </span>
                    <span className="fs-6" style={{ color: "#0A2458" }}>
                      /month
                    </span>
                  </div> */}

                  <ul
                    className="text-start mb-4"
                    style={{ listStyle: "none", padding: 0 }}
                  >
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Critical: 2-hour response
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Proactive performance monitoring
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        10 hours monthly enhancements
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Email + Slack + Phone support
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Dedicated support manager
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Priority feature development
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        After-hours support
                      </span>
                    </li>
                    <li className="mb-2 d-flex align-items-center gap-2">
                      <span style={{ color: "#0a2458" }}>✓</span>
                      <span style={{ color: "#0A2458" }}>
                        Monthly strategic reviews
                      </span>
                    </li>
                  </ul>

                  <button
                    onClick={() =>
                      (window.location.href =
                        "https://topmate.io/pluralcode/1677497?plan=premium")
                    }
                    className="btn w-100 py-3"
                    style={{
                      background:
                        "linear-gradient(135deg, #FFD700 0%, #FFC107 100%)",
                      border: "none",
                      color: "#0a2458",
                      fontWeight: "600",
                      borderRadius: "8px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 10px 20px rgba(255, 215, 0, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "none";
                    }}
                  >
                    Choose Premium
                  </button>
                </div>
              </div>
            </div>

            <div className="text-center mb-5">
              <p
                className="fs-6"
                style={{ color: "#0A2458", fontStyle: "italic" }}
              >
                *Exact pricing depends on application complexity, user volume,
                and specific requirements
              </p>
            </div>

            <div
              className="p-5 rounded-4"
              style={{
                background:
                  "linear-gradient(135deg, rgba(10, 36, 88, 0.03) 0%, rgba(10, 36, 88, 0.01) 100%)",
                border: "1px solid rgba(10, 36, 88, 0.1)",
              }}
            >
              <h3
                className="text-center mb-4 fw-bold"
                style={{ color: "#0a2458" }}
              >
                All Plans Include:
              </h3>
              <div className="row g-3">
                {[
                  "Proactive Monitoring",
                  "Regular Backups",
                  "Documentation Updates",
                  "No Setup Fees",
                  "Transparent Reporting",
                  "Flexible Contracts",
                  "Security Patches",
                  "Compatibility Updates",
                ].map((feature, index) => (
                  <div className="col-md-3 col-6" key={index}>
                    <div className="d-flex align-items-center gap-2">
                      <div style={{ color: "#0a2458", fontSize: "20px" }}>
                        ✓
                      </div>
                      <span style={{ color: "#0A2458" }}>{feature}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* WHY CHOOSE US - Modern Cards */}
        <section
          className="py-100"
          style={{ padding: "100px 0", background: "#F8FAFF" }}
        >
          <div className="container">
            <div className="text-center mb-5">
              <span
                className="px-3 py-1 rounded-pill d-inline-block mb-3"
                style={{
                  background: "rgba(10, 36, 88, 0.1)",
                  color: "#0a2458",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                WHY CHOOSE US
              </span>
              <h2
                className="display-4 fw-bold mb-4"
                style={{ color: "#0a2458" }}
              >
                Why Choose Our Support Services
              </h2>
            </div>

            <div className="row g-4">
              {[
                {
                  icon: "🧠",
                  title: "We Built It",
                  description:
                    "We know your codebase intimately. No ramp-up time, no knowledge transfer needed. We designed and built it—we maintain it best.",
                },
                {
                  icon: "⚡",
                  title: "Fast Response",
                  description:
                    "Not outsourced, not overseas. Direct access to the developers who built your software. Quick understanding, quick fixes.",
                },
                {
                  icon: "📊",
                  title: "Proactive Monitoring",
                  description:
                    "We don't wait for you to report problems. Monitoring alerts us to issues—often before they impact users.",
                },
                {
                  icon: "🔮",
                  title: "Strategic Partnership",
                  description:
                    "We're not just fixing bugs—we're helping evolve your software strategically as your business grows and changes.",
                },
                {
                  icon: "💰",
                  title: "Cost-Effective",
                  description:
                    "Much more affordable than hiring in-house developers. Get expert support without full-time salaries, benefits, recruitment costs.",
                },
                {
                  icon: "🌏",
                  title: "International Experience",
                  description:
                    "Time zone coverage for US, Australia, New Zealand, Singapore, Canada. We understand international business requirements.",
                },
              ].map((item, index) => (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div
                    className="h-100 p-4 rounded-4 text-center"
                    style={{
                      background: "white",
                      border: "1px solid rgba(10, 36, 88, 0.1)",
                      boxShadow: "0 5px 15px rgba(10, 36, 88, 0.05)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 15px 30px rgba(10, 36, 88, 0.1)";
                      e.currentTarget.style.borderColor = "#0a2458";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 5px 15px rgba(10, 36, 88, 0.05)";
                      e.currentTarget.style.borderColor =
                        "rgba(10, 36, 88, 0.1)";
                    }}
                  >
                    <div
                      className="mx-auto mb-4 rounded-3 d-flex align-items-center justify-content-center"
                      style={{
                        fontSize: "40px",
                        width: "80px",
                        height: "80px",
                        background: "rgba(10, 36, 88, 0.1)",
                      }}
                    >
                      {item.icon}
                    </div>
                    <h3
                      className="fs-5 fw-bold mb-3"
                      style={{ color: "#0a2458" }}
                    >
                      {item.title}
                    </h3>
                    <p className="fs-6 mb-0" style={{ color: "#0A2458" }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* SUPPORT PROCESS */}
        <section
          className="py-100"
          style={{ padding: "100px 0", background: "#FFFFFF" }}
        >
          <div className="container">
            <div className="text-center mb-5">
              <span
                className="px-3 py-1 rounded-pill d-inline-block mb-3"
                style={{
                  background: "rgba(255, 215, 0, 0.15)",
                  color: "#0a2458",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                OUR PROCESS
              </span>
              <h2
                className="display-4 fw-bold mb-4"
                style={{ color: "#0a2458" }}
              >
                How Our Support Works
              </h2>
              <p
                className="fs-5 mx-auto"
                style={{ maxWidth: "700px", color: "#0A2458" }}
              >
                Clear, transparent process for efficient issue resolution and
                enhancement delivery
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  step: "1",
                  title: "You Report an Issue",
                  items: [
                    "How: Email, Slack, support portal, or phone (Premium)",
                    "Include: Description, screenshots, steps to reproduce",
                    "Automatic: Ticket created, priority assigned",
                  ],
                },
                {
                  step: "2",
                  title: "We Acknowledge & Assess",
                  items: [
                    "Timeframe: Within response time (2-8 hours based on plan + priority)",
                    "We do: Acknowledge receipt, assess severity, assign developer",
                    "You get: Confirmation, expected resolution timeline",
                  ],
                },
                {
                  step: "3",
                  title: "Investigation & Resolution",
                  items: [
                    "We do: Reproduce issue, diagnose root cause, develop fix, test thoroughly",
                    "Communication: Updates throughout process",
                    "Timeline: Based on complexity and priority",
                  ],
                },
                {
                  step: "4",
                  title: "Deployment & Verification",
                  items: [
                    "We do: Deploy fix to production, monitor closely, verify resolution",
                    "You do: Confirm issue resolved",
                    "Documentation: Update docs if needed",
                  ],
                },
              ].map((step, index) => (
                <div className="col-lg-6" key={index}>
                  <div
                    className="h-100 p-4 rounded-4 position-relative"
                    style={{
                      background: "white",
                      border: "1px solid rgba(10, 36, 88, 0.1)",
                      boxShadow: "0 10px 30px rgba(10, 36, 88, 0.08)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 20px 40px rgba(10, 36, 88, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 30px rgba(10, 36, 88, 0.08)";
                    }}
                  >
                    <div
                      className="position-absolute start-0 mt-[-10px] ms-4"
                      style={{
                        width: "60px",
                        top: "-10%",
                        height: "60px",
                        background:
                          "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "white",
                        fontSize: "24px",
                        fontWeight: "bold",
                        boxShadow: "0 10px 20px rgba(10, 36, 88, 0.2)",
                      }}
                    >
                      {step.step}
                    </div>

                    <h3
                      className="fs-4 fw-bold mb-4"
                      style={{ color: "#0a2458", paddingTop: "20px" }}
                    >
                      {step.title}
                    </h3>

                    <ul className="mb-0" style={{ paddingLeft: "20px" }}>
                      {step.items.map((item, idx) => (
                        <li
                          key={idx}
                          className="mb-2"
                          style={{ color: "#0A2458" }}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* NEXT STEPS / CTA */}
        <section
          className="py-100"
          style={{
            padding: "100px 0",
            background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Background pattern */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255, 215, 0, 0.1) 2px, transparent 2px)`,
              backgroundSize: "40px 40px",
            }}
          />

          <div className="container position-relative" style={{ zIndex: 1 }}>
            <div className="text-center mb-5">
              <span
                className="px-3 py-1 rounded-pill d-inline-block mb-3"
                style={{
                  background: "rgba(255, 255, 255, 0.15)",
                  color: "white",
                  fontWeight: "600",
                  fontSize: "14px",
                  backdropFilter: "blur(10px)",
                }}
              >
                GET STARTED
              </span>
              <h2 className="display-4 fw-bold mb-4" style={{ color: "white" }}>
                Ready for Reliable Ongoing Support?
              </h2>
              <p
                className="fs-5 mx-auto"
                style={{
                  color: "rgba(255, 255, 255, 0.9)",
                  maxWidth: "700px",
                }}
              >
                Whether you have existing software needing support or you're
                planning new development, let's discuss the right support
                approach for your needs.
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  title: "For Existing Custom Software",
                  description:
                    "Already have custom software (from us or another developer)?",
                  steps: [
                    "Schedule assessment call",
                    "We review your application",
                    "Recommend appropriate support plan",
                    "Start support within days",
                  ],
                  buttonText: "Get Support Assessment →",
                  planType: "support",
                },
                {
                  title: "For New Development Projects",
                  description: "Planning custom software development?",
                  steps: [
                    "Discuss support needs during planning",
                    "Factor ongoing costs into budget",
                    "Seamless transition from development to support",
                    "Support plan activates at launch",
                  ],
                  buttonText: "Discuss New Project →",
                  planType: "project",
                },
                {
                  title: "Questions About Support",
                  description: "Not sure what you need?",
                  steps: [
                    "Explain your current situation",
                    "Discuss support options",
                    "No pressure, just clarity",
                  ],
                  buttonText: "Ask Questions →",
                  planType: "questions",
                },
              ].map((card, index) => (
                <div className="col-lg-4" key={index}>
                  <div
                    className="h-100 p-4 rounded-4"
                    style={{
                      background: "rgba(255, 255, 255, 0.95)",
                      backdropFilter: "blur(10px)",
                      boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 30px 50px rgba(0,0,0,0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 20px 40px rgba(0,0,0,0.1)";
                    }}
                  >
                    <h3
                      className="fs-4 fw-bold mb-3"
                      style={{ color: "#0a2458" }}
                    >
                      {card.title}
                    </h3>

                    <p className="fs-6 mb-4" style={{ color: "#0A2458" }}>
                      {card.description}
                    </p>

                    <ul className="mb-4" style={{ paddingLeft: "20px" }}>
                      {card.steps.map((step, idx) => (
                        <li
                          key={idx}
                          className="mb-2 d-flex align-items-center gap-2"
                        >
                          <span style={{ color: "#0a2458", fontSize: "20px" }}>
                            →
                          </span>
                          <span style={{ color: "#0A2458" }}>{step}</span>
                        </li>
                      ))}
                    </ul>

                    <button
                      onClick={() =>
                        (window.location.href = `https://topmate.io/pluralcode/1677497?type=${card.planType}`)
                      }
                      className="btn w-100 py-3"
                      style={{
                        background:
                          "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                        border: "none",
                        color: "white",
                        fontWeight: "600",
                        borderRadius: "8px",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                          "0 10px 20px rgba(10, 36, 88, 0.3)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      {card.buttonText}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-5">
              <div
                className="p-4 rounded-4"
                style={{
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                  width: "75%",
                  display: "inline-block",
                }}
              >
                <div className="row g-4">
                  <div className="col-md-4">
                    <div className="text-center">
                      <div
                        className="fs-6 mb-1"
                        style={{ color: "rgba(255, 255, 255, 0.8)" }}
                      >
                        Email
                      </div>
                      <div className="fs-5 fw-bold" style={{ color: "white" }}>
                        info@pluralcode.com
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center">
                      <div
                        className="fs-6 mb-1"
                        style={{ color: "rgba(255, 255, 255, 0.8)" }}
                      >
                        Call
                      </div>
                      <div className="fs-5 fw-bold" style={{ color: "white" }}>
                        +91 99589 20231
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center">
                      <div
                        className="fs-6 mb-1"
                        style={{ color: "rgba(255, 255, 255, 0.8)" }}
                      >
                        Response Time
                      </div>
                      <div
                        className="fs-5 fw-bold"
                        style={{ color: "#FFD700" }}
                      >
                        Within 2 Hours
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p
                className="fs-6 mt-4 mb-0"
                style={{ color: "rgba(255, 255, 255, 0.9)" }}
              >
                Serving businesses across 20+ industries worldwide
              </p>
            </div>
          </div>
        </section>

        {/* CSS for responsive padding */}
        <style jsx>{`
          .py-100 {
            padding: 100px 0;
          }

          .min-vh-80 {
            min-height: 80vh;
          }

          .fs-12 {
            font-size: 12px;
          }

          @media (max-width: 768px) {
            .py-100 {
              padding: 60px 0;
            }

            .display-4 {
              font-size: 2.5rem !important;
            }

            .display-5 {
              font-size: 2rem !important;
            }

            .display-3 {
              font-size: 2.5rem !important;
            }
          }
        `}</style>
      </main>
    </div>
  );
}
